export const inputStartSuffix = '-start';
export const inputEndSuffix = '-end';
